<div *ngIf="!show.accounts" class="table-fms max-height-100pcnt">
  <table>
    <colgroup>
      <col span="1" class="width-2pcnt" />
      <col span="1" class="width-50pcnt" />
      <col span="1" class="width-12pcnt" />
      <col span="1" class="width-12pcnt left-col" />
      <col span="1" class="width-12pcnt right-col" />
      <col span="1" class="width-12pcnt" />
    </colgroup>

    <thead>
    <tr>
      <th class="blank-space no-hover" colspan="3">
        <div class="font-1 bold600 flex-center-space-between">{{ isPL ? 'Accumulated profit and loss' : 'Balance sheet' }}</div>
      </th>
      <th class="box left-right bordered-upper-th" colspan="2">
        <div class="centered-row-container">Adjustments</div>
      </th>
      <th class="size-m blank-space no-hover">
        <div *ngIf="isAdmin" class="end-row-container row-gap-0p5">
          <app-button
            data-qa="add-manual-entry-modal"
            [type]="'accent'"
            [size]="'xsmall'"
            [showIcon]="'left'"
            [iconName]="'plus.svg'"
            [disabled]="financialStatement.isCompleted"
            (buttonClick)="manualEntryModalEmitterCatcher()"
          >
            Adjustment
          </app-button>
        </div>
      </th>
    </tr>
    <tr>
      <th id="three-dots-menu">
        <div>
          <app-three-dots-menu
            [matMenuTriggerFor]="menu"
            [attr.data-qa]="(isPL ? 'pl' : 'bs') + '-three-dot-menu'"
          >
          </app-three-dots-menu>
          <mat-menu #menu="matMenu">
            <ul class="list">
              <app-drop-down-item
                [attr.data-qa]="'assembly-' + (isPL ? 'pl' : 'bs') + '-three-dot-export'"
                class="width-100pcnt"
                [text]="'Export'"
                [iconNameAndStyling]="'excel.svg; icon-size-1p25'"
                (click)="exportExcel()">
              </app-drop-down-item>
              <app-drop-down-item *ngIf="isAdmin"
                [attr.data-qa]="'assembly-' + (isPL ? 'pl' : 'bs') + '-three-dot-copy-struct'"
                class="width-100pcnt"
                [text]="'Copy structure'"
                [iconNameAndStyling]="'copy-outline.svg; icon-size-1p25'"
                [disabled]="(financialStatement.isCompleted)"
                (click)="!financialStatement.isCompleted ? threeDotMenuEmitter.emit('copyStruct') : ''">
              </app-drop-down-item>
              <app-drop-down-item *ngIf="isAdmin"
                [attr.data-qa]="'assembly-' + (isPL ? 'pl' : 'bs') + '-three-dot-clear-struct'"
                class="width-100pcnt"
                [text]="'Clear structure'"
                [iconNameAndStyling]="'delete.svg; icon-size-1p25'"
                [menuItemClass]="'red-10'"
                [disabled]="(financialStatement.isCompleted)"
                (click)="!financialStatement.isCompleted ? threeDotMenuEmitter.emit('clearStruct') : ''">
              </app-drop-down-item>
            </ul>
          </mat-menu>
        </div>
      </th>
      <th class="size-xxl"></th>
      <th class="size-s text-center">Original balance</th>
      <th class="size-s text-center box left ">Debit</th>
      <th class="size-s text-center box right">Credit</th>
      <th class="size-s text-center">Balance after adjustments</th>
    </tr>
    </thead>

    <tbody *ngFor="let part of parts; let i = index"  cdkDropList (cdkDropListDropped)="drop($event, part)">
    <tr class="clickable" (click)="closePart(part.partName)">
      <td>
        <app-table-group-icon
          [opened]="show.parts[part.partName]"
        >
        </app-table-group-icon>
      </td>
      <td class="first-level-left-sticky body-header" colspan="2">
        <div class="start-row-container row-gap-0p625">
            <span class="light-bold">
              {{ part.partName }}
            </span>
          <app-button *ngIf="isAdmin"
            [attr.data-qa]="'assembly-' + (isPL ? 'pl' : 'bs') + '-add-item-button'"
            [size]="'xsmall'"
            [iconName]="'plus.svg'"
            [disabled]="financialStatement.isCompleted"
            (click)="$event.stopPropagation()"
            (buttonClick)="nameItem(part)"
          >
            Add item
          </app-button>
        </div>
      </td>
      <td class="box left-right" colspan="2"></td>
      <td></td>
    </tr>

    <ng-container
      *ngIf="show.parts[part.partName]"
    >
      <!-- add drag drop here -->
      <ng-container *ngFor="let item of part.financialStatementItems"
      >
        <tr class="row-color draggable"
            [ngClass]="{
              'plain': item !== selectedItem || !isAllocating,
              'opacity0p5 no-propagation': item.name === accumulatedProfitAndLossItemName
              }"
            cdkDrag
        >
          <td *ngIf="item.name === accumulatedProfitAndLossItemName" class="text-center">
            P&L
          </td>
          <td *ngIf="item.name !== accumulatedProfitAndLossItemName" id="twoLines" cdkDragHandle
              [cdkDragHandleDisabled]="!isAdmin || financialStatement.isCompleted || item.name === accumulatedProfitAndLossItemName">
              <app-all-icons *ngIf="isAdmin && item.name !== accumulatedProfitAndLossItemName" class="drag-svg"
                [class.disabled-icon]="financialStatement.isCompleted"
                [iconNameAndStyling]="'drop-icon.svg; drag-icon icon-size-1p375 cursor-grab'">
              </app-all-icons>
          </td>
          <td>
            <div
              class="start-row-container row-gap-0p75"
              *ngVar="item.financialStatementAccounts.length as amountOfAccounts"
            >
              <div class="start-row-container row-gap-0p25">
                <app-three-dots-menu
                  [attr.data-qa]="'assembly-' + (isPL ? 'pl' : 'bs') + '-item-three-dotted'"
                  *ngIf="isAdmin"
                  [matMenuTriggerFor]="itemMenu"
                >
                </app-three-dots-menu>
                <mat-menu #itemMenu="matMenu">
                  <ul class="list">
                    <app-drop-down-item
                      *ngIf="item.name !== accumulatedProfitAndLossItemName && isAdmin"
                      [attr.data-qa]="'assembly-' + (isPL ? 'pl' : 'bs') + '-item-allocate-account'"
                      class="width-100pcnt"
                      [text]="'Allocate accounts'"
                      [iconNameAndStyling]="'allocate.svg; icon-size-1p25'"
                      [disabled]="financialStatement.isCompleted"
                      (click)="selectAccountsToAdd(part, item)">
                    </app-drop-down-item>
                    <app-drop-down-item
                      *ngIf="!fixedItemNames.includes(item.name) && isAdmin"
                      [attr.data-qa]="'assembly-' + (isPL ? 'pl' : 'bs') + '-item-edit'"
                      class="width-100pcnt"
                      [text]="'Edit'"
                      [iconNameAndStyling]="'edit-outline.svg; icon-size-1p25'"
                      [disabled]="financialStatement.isCompleted"
                      (click)="!financialStatement.isCompleted && isAdmin ? nameItem(part, item) : ''">
                    </app-drop-down-item>
                    <app-drop-down-item
                      *ngIf="!baseFinancialStatementItems.partnersCapitalItems.includes(item.name) && isAdmin"
                      [attr.data-qa]="'assembly-' + (isPL ? 'pl' : 'bs') + '-item-remove'"
                      class="width-100pcnt"
                      [text]="'Delete'"
                      [iconNameAndStyling]="'delete.svg; icon-size-1p25'"
                      [menuItemClass]="'red-10'"
                      [disabled]="financialStatement.isCompleted"
                      (click)="!financialStatement.isCompleted && isAdmin ? showAndSetItemDeleteModal(part, item) : ''">
                    </app-drop-down-item>
                  </ul>
                </mat-menu>
                <div
                  appShortenWithoutHover="30" [text]="item.name | uppercase">
                </div>
                <app-chain-icon
                  *ngIf="item.assetsAndLiabilities"
                ></app-chain-icon>
              </div>
              <app-button *ngIf="isAdmin"
                [attr.data-qa]="'assembly-' + (isPL ? 'pl' : 'bs') + '-item-allocate-accounts-button'"
                class="hidden-button-until-hover whitespace-nowrap"
                [size]="'xsmall'"
                [iconName]="'allocate.svg'"
                (buttonClick)="selectAccountsToAdd(part, item)"
                [disabled]="financialStatement.isCompleted"
              >
                Allocate accounts
              </app-button>
              <app-button
                *ngIf="amountOfAccounts"
                [attr.data-qa]="'assembly-' + (isPL ? 'pl' : 'bs') + '-item-show-allocated-accounts'"
                class="hidden-button-until-hover no-background-button-wrapper"
                [size]="'xsmall'"
                (buttonClick)="showAllocatedAccounts(item)"
              >
                <div class="start-row-container row-gap-0p25 whitespace-nowrap">
                  <span> {{ amountOfAccounts }} account{{amountOfAccounts > 1 ? "s" : "" }} </span>
                  <app-all-icons [iconNameAndStyling]="'right-arrow.svg'"></app-all-icons>
                </div>
              </app-button>
            </div>
          </td>
          <td class="text-center">
            {{ item.sums.sumITP | switcherDashBraces : switcher : 0 }}
          </td>
          <td class="text-center box left">
            {{ item.sums.manualDebit | switcherDashBraces : switcher : 0 }}
          </td>
          <td class="text-center box right">
            {{ item.sums.manualCredit | switcherDashBraces : switcher : 0 }}
          </td>
          <td class="text-center">
            {{ item.sums.balance | switcherDashBraces : switcher : 0 }}
          </td>
        </tr>
      </ng-container>
    </ng-container>
    <tr class="total light-bold text-center">
      <td></td>
      <td class="text-left">Total {{ part.partName }}</td>
      <td>
        {{ part.sums.sumITP | switcherDashBraces : switcher : 0 }}
      </td>
      <td class="box left">
        {{ part.sums.manualDebit | switcherDashBraces : switcher : 0 }}
      </td>
      <td class="box right">
        {{ part.sums.manualCredit | switcherDashBraces : switcher : 0 }}
      </td>
      <td>
        {{ part.sums.balance | switcherDashBraces : switcher : 0 }}
      </td>
    </tr>
    </tbody>

    <tbody>
    <ng-container *ngVar="(isPL ? financialStatement.profitLossNetTotals : financialStatement.balanceSheetNetTotals) as netTotals">
      <tr class="text-center"
          *ngIf="netTotals"
          [ngClass]="isPL ? 'grand-total' :
            (netTotals.sumITP || netTotals.balance) ? 'bold700 bg-red-1 red-12' : 'bold700 bg-main-2 main-8'"
      >
        <td></td>
        <td class="text-left"> {{ isPL ? 'Total Profit and loss:' : 'Check:'}}</td>
        <td>
          {{ netTotals.sumITP | switcherDashBraces : switcher : 0 }}
        </td>
        <td class="box left">
          {{ netTotals.manualDebit | switcherDashBraces : switcher : 0 }}
        </td>
        <td class="box right">
          {{ netTotals.manualCredit | switcherDashBraces : switcher : 0 }}
        <td>
          {{ netTotals.balance | switcherDashBraces : switcher : 0 }}
        </td>
      </tr>
      <tr
        *ngIf="!isPL && netTotals && (netTotals.sumITP || (netTotals.manualDebit - netTotals.manualCredit))"
        class="bg-main-red-light"
      >
        <td colspan="3"></td>
        <td colspan="3">
          <!--assets + liabilities (negative)-->
          <div
            class="br-0p75 padding-0p25-0p5 row-gap-0p25 bg-white-12 start-row-container"
          >
            <app-all-icons
              [iconNameAndStyling]="'exclamation.svg'"
              class="red-10"
            ></app-all-icons>
            <span class="font-5">
              <span class="bold600">{{TOTAL_CHECK_FAILED_TEXT.title}}</span> {{TOTAL_CHECK_FAILED_TEXT.description}}
            </span>
          </div>
        </td>
      </tr>
    </ng-container>
    </tbody>
  </table>
</div>


<section *ngIf="!show.accounts && unallocatedFSData.accounts.length"
         [ngClass]="(unallocatedFSData.isUnallocatedCheck) ? 'bg-red-1' : unallocatedFSData.accounts.length !== 0 ? 'bg-orange-1' : 'bg-main-2'"
         class="section-item-wrapper"
         [class.opened]="!show.unallocatedAccounts">
  <div class="header-with-hide-img space-between-horizontal-align clickable"
       (click)="show.unallocatedAccounts = !show.unallocatedAccounts">
    <div class="start-row-container">
      <app-table-group-icon [opened]="show.unallocatedAccounts"></app-table-group-icon>
      <app-all-icons
        [iconNameAndStyling]="'warning.svg; icon-size-1p5em;' + (unallocatedFSData.isUnallocatedCheck ? 'red-10' : 'orange-10')"
        [buttonTooltip]="unallocatedFSData.unallocatedTooltip">
      </app-all-icons>
      {{ unallocatedFSData.accounts.length }} unallocated accounts
    </div>
  </div>
  <div [ngClass]="(show.unallocatedAccounts) ? 'pd-top-1' : ''" class="green-scroll">
    <app-trial-balance
      *ngIf="show.unallocatedAccounts"
      [isDrilldown]="true"
      [isLocked]="financialStatement.isCompleted || !isAdmin"
      [tbData]="unallocatedFSData.accounts"
      (manualAccountEmitter)="manualAccountEmitter.emit($event)"
      (bulkDeleteEmitter)="bulkDeleteAccountsEmitter.emit($event)">
    </app-trial-balance>
  </div>
</section>


<div *ngIf="show.accounts">
  <div class="table-header-button-and-title-wrapper height-3p125 padding-0-0p625">
    <div class="start-row-container row-gap-0p5">
      <span
      class="clickable navigation-link start-row-container"
        (click)="show.accounts = false; isDrillDownEmitter.emit(false)"
      >
        <span> Assembly </span>
        <app-all-icons
          [iconNameAndStyling]="'right-arrow.svg'">
        </app-all-icons>
      </span>
      <span
        *ngIf="trialBalanceComponent"
        [ngClass]="{'clickable navigation-link': trialBalanceComponent?.show.glDrilldown}"
        (click)="trialBalanceComponent.show.glDrilldown=false"
      >
        {{ selectedItemForDrilldown?.partName }} - {{ selectedItemForDrilldown?.name | uppercase }}
      </span>
      <ng-container *ngIf="trialBalanceComponent?.show.glDrilldown" >
        <app-all-icons
          [iconNameAndStyling]="'right-arrow.svg'">
        </app-all-icons>
        <span *ngVar="trialBalanceComponent.selectedAccountForDrilldown.glTransactions.length as transactionsAmount">
          {{ trialBalanceComponent.selectedAccountForDrilldown.code }} -
          {{ trialBalanceComponent.selectedAccountForDrilldown.name }} |
          {{ transactionsAmount }}
          {{ transactionsAmount === 1 ? 'entry' : 'entries' }}
        </span>
      </ng-container>
    </div>
    <div class="end-row-container row-gap-0p5">
      <span class="start-row-container row-gap-0p25">
        From:
        <app-input-date
          data-qa="item-drilldown-date-picker"
          #accountFilterForDataDatePicker
          [maxDate]="accountFilterDataForDrilldown.selectedPeriod"
          [isRequired]="true"
          [isShrinked]="true"
          [(input)]="accountFilterDataForDrilldown.selectedDate"
          (inputChange)="drilldownFilterChange(accountFilterDataForDrilldown.selectedPeriod, $event)"
        >
        </app-input-date>
      </span>
      <span class="start-row-container row-gap-0p25">
        Till:
        <app-selector
          data-qa="item-drilldown-period-selector"
          class="font-3 width-11 black-9"
          [outerClass]="'control-shrinked-container'"
          [data]="accountFilterDataForDrilldown.selectorPeriods"
          [selectedItem]="accountFilterDataForDrilldown.selectedPeriod"
          (itemEmitter)="drilldownFilterChange($event, accountFilterDataForDrilldown.selectedDate)"
          >
        </app-selector>
      </span>
      <app-button
        class="resetButton"
        data-qa="reset-button-account-drilldown-filter"
        [type]="'dark-grey'"
        [size]="'small'"
        [bordersSquaredShape]="'full'"
        [disabled]="!accountFilterDataForDrilldown.selectedDate"
        [additionalClasses]="accountFilterDataForDrilldown.selectedDate ? '' : 'disabled'"
        (buttonClick)="resetAccountFiltersForDrilldown()">
        Reset
        </app-button>
    </div>
  </div>

  <app-trial-balance
    #itemDrilldown
    class="green-scroll"
    [isDrilldown]="true"
    [isLocked]="financialStatement.isCompleted || !isAdmin"
    [showTrialBalanceNavBar]="false"
    [tbData]="selectedItemForDrilldown.financialStatementAccounts"
    [accountFilterDataObject]="accountFilterDataForDrilldown"
    (manualAccountEmitter)="manualAccountEmitter.emit($event)"
    (bulkDeleteEmitter)="bulkDeleteAccountsEmitter.emit($event)">
  </app-trial-balance>
</div>

<app-save-with-name-modal
  *ngIf="show.modalForAddItem"
  [title]="'Item name'"
  [key]="'assembly'"
  [names]="objectForItemModal.existingNames"
  [dataObject]="objectForItemModal"
  [showCaps]="true"
  (isConfirmedName)="confirmName($event)">
</app-save-with-name-modal>

<app-allocation-modal class="green-scroll"
  *ngIf="show.modalForAddAccounts"
  (isConfirmedSelected)="confirmAccountSelection($event)"
  [dataObject]="objectForAccountsModal">
</app-allocation-modal>

<app-modal-dialog
  *ngIf="show.thinkTwiceModalItemDelete"
  [header]="'Delete item'"
  [mainText]="[objectForItemDeleteModal.description]"
  [addAdditionalText]="true"
  (isConfirmed)="confirmItemDelete($event)">
</app-modal-dialog>
